var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "sui-table",
    { attrs: { basic: "very", celled: "", padded: "", selectable: "" } },
    [
      _c(
        "sui-table-header",
        [
          _c(
            "sui-table-row",
            [
              _c("sui-table-header-cell"),
              _vm._l(_vm.columns, function (column, index) {
                return _c("sui-table-header-cell", { key: index }, [
                  _vm._v(" " + _vm._s(column) + " "),
                ])
              }),
            ],
            2
          ),
        ],
        1
      ),
      _vm.attestationSubmissionStatus
        ? _c(
            "sui-table-body",
            _vm._l(
              _vm.attestationSubmissionStatus,
              function (submission, index) {
                return _c(
                  "sui-table-row",
                  {
                    key: index,
                    attrs: { positive: _vm.hasSubmitted(submission.status) },
                  },
                  [
                    _c("sui-table-cell", [_vm._v(_vm._s(index + 1))]),
                    _c("sui-table-cell", [
                      _vm._v(_vm._s(_vm.name(submission))),
                    ]),
                    _c("sui-table-cell", [
                      _vm._v(_vm._s(submission.first_name)),
                    ]),
                    _c("sui-table-cell", [
                      _vm._v(_vm._s(submission.last_name)),
                    ]),
                    _c("sui-table-cell", [_vm._v(_vm._s(submission.email))]),
                    _c("sui-table-cell", [_vm._v(_vm._s(submission.status))]),
                    _c("sui-table-cell", [
                      _vm._v(_vm._s(submission.firm_name)),
                    ]),
                  ],
                  1
                )
              }
            ),
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }